import * as Sentry from '@sentry/browser';
import { getEnvVariable } from './getEnvVariable';
import { beforeSend } from './sentryBeforeSend';

// Initialize at app boot (called from index.tsx) so exceptions thrown during
// device/client setup are captured. Initializing inside a useEffect runs after
// `useSetupDeviceAndClient`, so any boot-time `captureException` would be dropped.
export const initSentry = () => {
  const dsn = getEnvVariable('REACT_APP_SENTRY_DSN', '');
  if (!dsn) {
    console.warn('REACT_APP_SENTRY_DSN not set; Sentry is disabled.');
    return;
  }

  Sentry.init({
    dsn,
    release: getEnvVariable('REACT_APP_HEROKU_RELEASE_VERSION', 'unknown'),
    environment: getEnvVariable('REACT_APP_ENV_NAME', 'production'),
    sampleRate: 1.0,
    tracesSampleRate: 0,
    normalizeDepth: 6,
    beforeSend
  });
};
